import firebase from "firebase";


export default {
    async getVendorName(user){
        const db = firebase.firestore();
        if (user  === null) {
            return ''
        }
        const snapshot = await db.collection('vendors').where('userId', '==', user.uid).get()
        try {
            return snapshot.docs[0].id;
        }catch (TypeError){
            return '';
        }
    },
    async getDocuments(uid, limit, lastVisible){
        const db = firebase.firestore();
        let query = db.collection(`users/${uid}/documents`).limit(limit).orderBy('createdAt', 'desc')
        if (lastVisible) {
            query = query.startAt(lastVisible.createdAt)
        }
        return await query.get()
    },
     async getDocumentsFiltered(uid, docType, dateFrom, dateTo){
        const db = firebase.firestore();
        let query = db.collection(`users/${uid}/documents`).limit(1000)
        if (docType) {
            query = query.where('type', '==', docType)
        }
        console.log(dateFrom, dateTo)
        // @todo make filtering work (tried with index, did not work)
        /* if (dateFrom) {
            query = query.orderBy('createdAt', 'desc').startAt(dateFrom)
        }
        if (dateTo) {
            query = query.where('createdAt', '<', dateTo)
        } */
        return await query.get()
    },
    async getVendorData(vendorName){
        const db = firebase.firestore();
        const snapshot = await db.collection(`vendors`).doc(vendorName).get()
        try {
            return snapshot.data()
        } catch (TypeError) {
            return {}
        }
    },
    async getUserProfile(uid) {
        const db = firebase.firestore();
        const ref = db.collection('users').doc(uid)
        const user = await ref.get()
        if (user.exists) {
            return user.data()
        }
        return {}
    },
    async saveUserProfile(uid, data) {
        const db = firebase.firestore();
        const ref = db.collection('users').doc(uid)
        const user = await ref.get()
        if (user.exists) {
            await ref.update(data)
        } else {
            await ref.set(data)
        }
        return await ref.get().then(doc => doc.data())
    },
}